import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';
import { MaintenanceInfoService } from '../../services/maintenance-info.service';
import { MaintenanceInfo } from '../../models/maintenanceInfo';
import { NgClass } from '@angular/common';
import { DateEvalPipe } from '../../pipes/date-eval.pipe';
import { Message } from 'primeng/message';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-maintenance-info',
  templateUrl: './maintenance-info.component.html',
  imports: [Message, NgClass, DateEvalPipe],
})
export class MaintenanceInfoComponent implements OnInit {
  language = 'en';

  typeToIconMap = {
    info: 'info',
    warning: 'warning',
    danger: 'report',
    success: 'check_circle',
  };

  typeToSeverityMap = {
    info: 'info',
    warning: 'warn',
    danger: 'error',
    success: 'success',
  } as const;

  protected readonly dayjs = dayjs;

  private infoService = inject(MaintenanceInfoService);
  private translationService = inject(TranslateService);

  info = toSignal(this.infoService.getMaintenanceInfo(), {
    initialValue: [] as MaintenanceInfo[],
  });

  ngOnInit() {
    this.language = this.translationService.currentLang;
    this.translationService.onLangChange.subscribe((event) => {
      this.language = event.lang;
    });
  }
}
